<div class="modal-header">
  <h3>Bestell-Nr. bereits vorhanden</h3>
</div>
<div class="modal-body">
  <p>Die Bestell-Nr. ist bereits in einem anderen Auftrag vorhanden:</p>
  @for (workflowId of workflowIds; track workflowId) {
    <p>
      <a [href]="'/workflow/' + workflowId | appHref" target="_blank">Vorgang: {{workflowId}}</a>
    </p>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="dismiss()">Ok</button>
</div>
